import { axiosInstance as axios, axiosApi } from '../lib/axios';
import { pickClient } from '../lib/apimRoutes';
import Config from '../config/environments';
import { POST_POST, LIST_POST, LIST_POST_SELETO } from '../actionTypes/post';
import { viewsModelToModels, viewsModelToModelsApi } from '../mapper/post';
import updateState from './common/common';
import updateStateApi from './common/commonapi';

export const getDataPost = (data, state) => async (dispatch) => {
  const base = {
    type: LIST_POST,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.POST.URL}/${data.userId}/${Config.POST.END_URL}`;
  const client = pickClient('GET', url);

  client.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data, state);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const getSimilarPosts = (data, state) => async (dispatch) => {
  const base = {
    type: LIST_POST,
    payload: {},
    state: true,
    success: true,
  };

  // const url = `${Config.POST.URL}/${data.userId}/${Config.POST.END_URL}`;
  const url = `${Config.SIMILAR_POST.URL}?limit=12&offset=0&postId=${data.postId}&maxDistance=2000`;

  axiosApi.get(url).then((response) => {
    base.payload = updateStateApi(response);
    base.payload.data = viewsModelToModelsApi(base.payload.data, state);
    console.log(response);
    console.log('Data', base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const getDataPostSeleto = (data, state) => async (dispatch) => {
  const base = {
    type: LIST_POST_SELETO,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.POST.URL}/${data.userId}/${Config.POST.END_URL}`;
  const client = pickClient('GET', url);

  client.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data, state);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const getDataPostWithoutPagination = () => async (dispatch) => {
  const base = {
    type: LIST_POST,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.POST.URL}/?page=1&quantity=100`;

  axios.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const postDataPost = (data) => async (dispatch) => {
  const base = {
    type: POST_POST,
    payload: {},
    state: true,
    success: true,
  };

  const url = Config.POST.URL;

  axios.post(url, data).then((response) => {
    base.payload = updateState(response);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const putDataPost = (data) => async (dispatch) => {
  const base = {
    type: POST_POST,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.POST.URL}/${data.uuid}`;

  axios.put(url, data).then((response) => {
    base.payload = updateState(response);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};
